<template>
  <div class="color-property">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <div class="color-input-container">
      <div class="color-preview" :style="{ backgroundColor: element }" @click="showColorPicker = true"></div>
      <span class="color-value">{{ element }}</span>
    </div>
    <ColorPickerPopup 
      :show="showColorPicker" 
      :color="element"
      :noAlpha="property.noAlpha != undefined ? property.noAlpha : false"
      @close="showColorPicker = false"
      @update="updateColor"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import ColorPickerPopup from "../PopupComponents/ColorPickerPopup.vue";
import Tooltip from "../Tooltip.vue";

export default {
  name: 'ColorInput',
  components: {
    ColorPickerPopup,
    Tooltip
  },
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: [Number, String],
      required: true
    },
    container: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showColorPicker: false
    }
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY,
    }),
    updateColor(newColor) {
      this.updateProperty({element: this.container, property: this.property, value: newColor})
    }
  }
}
</script>

<style scoped>
.property-label {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
}
.color-property {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.color-property label {
  color: #e5e7eb;
  font-size: 0.875rem;
  font-weight: 500;
}

.color-input-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.color-preview {
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

.color-preview:hover {
  border-color: #3b82f6;
}

.color-value {
  color: #e5e7eb;
  font-size: 0.875rem;
  font-family: monospace;
}
</style>
